
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.main-text {
  margin-bottom: 1rem;
  align-self: center;
  font-size: 0.875rem;
  text-transform: uppercase;
  color: var(--performance-gray-2);
  margin-right:1rem !important
}

.content {
  gap: 1rem
}

@media (min-width: 768px) {

  .content {
    min-height: 28rem
  }
}

.legends {
  margin-top: 2rem;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.legends ul {
  margin: 0px
}

.legends ul {
  margin-bottom: 1rem
}

.legends ul {
  display: flex
}

.legends ul {
  list-style-type: none
}

.legends ul {
  flex-wrap: wrap
}

.legends ul {
  row-gap: 0.5rem
}

.legends ul {
  padding: 0px
}

@media (min-width: 480px) {

  .legends ul {
    width: 100%
  }
}

@media (min-width: 768px) {

  .legends ul {
    width: -moz-fit-content;
    width: fit-content
  }
}

@media (min-width: 768px) {

  .legends ul {
    justify-content: flex-start
  }
}

.legends li {
  margin-right: 1rem
}

.legends p {
  margin: 0px
}

.legends p {
  display: flex
}

.legends p {
  align-items: center
}

.legends p {
  font-size: 0.875rem
}

.legends p {
  color: var(--performance-gray-2)
}

.legends span {
  margin-right: 0.25rem
}

.legends span.increased, .legends span.on-track {
  color: var(--green-quality-darken-2)
}

.legends span.steady, .legends span.on-watch {
  color: var(--performance-orange)
}

.legends span.decreased, .legends span.off-track {
  color: var(--status-error)
}

.legends span.monitor {
  color: var(--performance-gray)
}

.legends span.coming-soon {
  color: var(--performance-blue)
}

.legends span.circle {
  box-sizing: border-box
}

.legends span.circle {
  display: flex
}

.legends span.circle {
  height: -moz-fit-content;
  height: fit-content
}

.legends span.circle {
  width: -moz-fit-content;
  width: fit-content
}

.legends span.circle {
  align-items: center
}

.legends span.circle {
  justify-content: center
}

.legends span.circle {
  border-radius: 9999px
}

.legends span.circle {
  padding: 0.375rem
}

.legends span.circle {
  color: var(--neutral-white)
}

.legends span.circle-green {
  background-color: var(--green-quality-darken-2)
}

.legends span.circle-orange {
  background-color: var(--performance-orange)
}

.legends span.circle-red {
  background-color: var(--status-error)
}

.legends span.circle-gray {
  background-color: var(--performance-gray)
}

.legends span.circle-blue {
  background-color: var(--performance-blue)
}
`;